/**
 * A failed request, carrying what the caller needs to react: the status to
 * branch on and, where the server named an offending field, its `path`.
 */
export class ApiError extends Error {
    readonly status: number;
    readonly path?: string;

    constructor(message: string, status: number, path?: string) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        if (path !== undefined) {
            this.path = path;
        }
    }
}
